<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData.data"
          height="700"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="order_no" label="订单号" width="260">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div>{{ scope.row.order_no }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="姓名">
               <template slot-scope="scope" >
              <div>{{ scope.row.create_time }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="order_source" label="订单总单数">
                 <template slot-scope="scope" v-if="!scope.row.is_top_row">
               <div>{{ scope.row.order_source }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="total_price" label="总金额">
                <template slot-scope="scope" v-if="!scope.row.is_top_row">
               <div>{{ scope.row.total_price.toFixed(2) }}</div>
            </template>
          </el-table-column>
            <el-table-column prop="yihuan" label="已还期数\未还\逾期">
                <template slot-scope="scope" v-if="!scope.row.is_top_row">
               <div>{{scope.row.order_status}}</div>
            </template>
          </el-table-column>
            <el-table-column prop="order_source_text" label="已还金额\未还\逾期">
                <template slot-scope="scope" v-if="!scope.row.is_top_row">
               <div>{{scope.row.order_source_text}}</div>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="anniu">
                <el-button
                  @click="gohuankuan(scope.row)"
                  type="primary"
                  size="small"
                  >订单</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 弹窗 -->
      <el-dialog title="还款详情" :visible.sync="dialogTableVisible">
        <el-table :data="gridData">
          <el-table-column prop="order_id" label="ID"></el-table-column>
          <el-table-column prop="username" label="姓名"></el-table-column>
          <el-table-column prop="order_no" label="订单号"></el-table-column>
          <el-table-column prop="product[0].product_name" width="150" label="商品名称"></el-table-column>
          <el-table-column prop="total_price" label="总金额"></el-table-column>
          <el-table-column prop="create_time" label="订单创建时间"></el-table-column>
          <el-table-column prop="je" label="已还金额/未/逾"></el-table-column>
          <el-table-column prop="qs" label="已还单量/未/逾"></el-table-column>

          <!-- <el-table-column label="已还金额/未/逾">
            <template slot-scope="scope">
            <span style="margin-left: 10px" >{{scope.row.je}}</span>
          </template>
          </el-table-column>
          <el-table-column property="price" label="已还单量/未/逾">
            <template slot-scope="scope">
            <span style="margin-left: 10px" >{{scope.row.qs}}</span>
          </template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <div class="anniu">
                <el-button @click="goxq(scope.row)" type="primary" size="small">订单详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <Logistics
      :logisticsData="logisticsData"
      :isLogistics="isLogistics"
      @closeDialog="closeLogistics"
    >
    </Logistics>
  </div>
</template>

<script>
import store from "@/store/";
import AuthApi from '@/api/auth.js';
import OrderApi from "@/api/order.js";
import { timeFormat } from "@/utils/timeFormat";
import FengkongApi from "@/api/fengkong.js";
import Logistics from "@/components/logistics/viewLogistics.vue";
import qs from "qs";
export default {
  name: "Login",
  components: {
    Logistics,
  },
  data() {
    return {
      gridData: "",
      dialogTableVisible: false,
        //已还
        yihuan:'',
        
        //未还
        weihuan:'',
    
        //逾期:
        yuq1:'',

      //总金额
      zong: "",
      changdu: "",
      //姓名
     create_time: "",
      //订单号
    //   dingdanhao2: "",
      // 签署id
      folwid: "",
      //碎屏险
      radio: "2",
      // order_id 订单id
      order_id: "",
      remarksText: "",
      remarksText1: "",
      // 输入框值
      yushou: "",
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        order_no: "",
        order_id:"",
        style_id: "",
        create_time: "",
        total_price: "",
        price: "",
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: "",
      create_time1: "",
      total_price: "",
      peice: "",

      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0,
      },
      isLogistics: false,
      logisticsData: {},
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    goxq(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },
    gohuankuan(row) {
      this.dialogTableVisible = true;
      let Params = {
        order_id: row.order_id
      }
      OrderApi.getduobilist(Params, true)
        .then(res => {
          console.log("成功", res);
          this.gridData = res.data.orderlist.data;
          for (let i = 0; i < res.data.orderlist.data.length; i++) {
            let shuzu = res.data.orderlist.data[i];
            let weihuanjine = 0
            let yuqi = 0
            let yuqi1 = 0
            let yuqi2 = 0
            let yuqi3 = 0
            for (let i = 0; i < shuzu.order_bill.length; i++) {
              let xunhuan =shuzu.order_bill[i]
              if(xunhuan.is_pay_status == 1){  // 已还
                yuqi1 += 1
              }else if(xunhuan.is_pay_status == 0){
                weihuanjine+=Number(xunhuan.price)
                yuqi2 += 1
              }else if(xunhuan.is_pay_status == 2){
                yuqi+=Number(xunhuan.price)
                yuqi3 += 1
              }
            }

            let yihuanjine = this.gridData[i].total_price - weihuanjine
            this.gridData[i].je = yihuanjine.toFixed(2) + '/' + weihuanjine.toFixed(2)  + '/'+ yuqi.toFixed(2) 
            this.gridData[i].qs = yuqi1 + '/' + yuqi2 + '/'+ yuqi3
          }
        })
        .catch(error => { });
    },
    //备注
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    gojiedong(row) {
      console.log("======", row.order_id);
      this.$confirm("确定要解冻?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info ",
      })
        .then(() => {
          let data = {
            order_id: row.order_id,
          };
          OrderApi.ysunfreeze(data, true)
            .then((res) => {
              console.log("成功res", res);
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getData();
            })
            .catch((error) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /*弹窗确定*/
    queding() {
      console.log(this.shneheList);
      if (this.shneheList.length <= 0) {
        this.$message({
          message: "请选择归还期数",
          type: "error",
        });
        return;
      }
      OrderApi.toExamine(
        {
          billid: this.shneheList,
        },
        true
      ).then((data) => {
        this.dialogVisible = false;
        console.log(data, "成功");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    async getData() {
      let self = this;
      self.loading = true;
      let Params = this.searchForm;
      var resp = await store.dispatch("common/getBaseInfo");
      if (resp.role != "") {
        if (resp.role[0].role_id == 4) {
          Params.tuiguang_id = Params.tuiguang_id;
        }
      } else {
        Params.tuiguang_id = "";
      }
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      OrderApi.orderlist5(Params, true).then((res) => {
          self.loading = false;
          let list = [];
          let zongjine = 0;
        //   res.data.uid.forEach((item) => {
        //       item.forEach(items=>{
        //         items.order_bill.forEach(itemss=>{
        //           console.log(itemss)
        //         })
        //       })
        //   })
          for (let i = 0; i < res.data.uid.length; i++) {
            let dingdanhao1 = "";
            let item = res.data.uid[i];

            let order_no=''
            let order_id =''
            let create_time=''
            let total_price=0
            let order_source=''
            let order_source_text=''
            let is_top_row= true
            let order_status=''
            let yihuanzong=0
            let wehuanzong=0
            let yuqizong=0
            let yihuan1=0
            let weihuan1=0
            let yuqi1=0
          

            for (let i = 0; i < item.length; i++) {
              let xunhuan = item[i];
              dingdanhao1 += xunhuan.order_no + ",";
              order_no += xunhuan.order_no + ",";
              order_id += xunhuan.order_id + ",";
              create_time = xunhuan.username
              this.create_time=create_time
              // this.dingdanhao2 = dingdanhao1;
              // this.changdu = item.length;
              order_source=item.length;
              zongjine += xunhuan.total_price;
              var asdasd = (zongjine += xunhuan.total_price);
              var qian1 = parseFloat(asdasd);
              this.zong = qian1;
              total_price = qian1
              //姓名
              this.username = xunhuan.username;
              let yihuan = 0;
              let weihuan = 0;
              let yuqi = 0;
              let yihaunjine=0
              let weihuanjine=0
              let yuqijine=0
              for (let i = 0; i < xunhuan.order_bill.length; i++) {

                let shuzu = xunhuan.order_bill[i];
               
                if (shuzu.is_pay_status == 0) {
                  yihuan += 1;
                } else if (shuzu.is_pay_status == 1) {
                  weihuan += 1;
                } else {
                  yuqi += 1;
                }
                if(shuzu.is_pay_status == 0){
               
                yihaunjine+=parseFloat(shuzu.price);
                       
                }else if(shuzu.is_pay_status==1){
                    weihuanjine+=parseFloat(shuzu.price)
                  
                }else{
                    yuqijine+=parseFloat(shuzu.price)
                 
                }
              }

             
                yihuanzong+=yihaunjine
                wehuanzong+=weihuanjine
                yuqizong+=yuqijine
                order_source_text =yihuanzong.toFixed(2) + '/' + wehuanzong.toFixed(2) + '/' + yuqizong.toFixed(2)
                yihuan1+=yihuan

                weihuan1+=weihuan
                yuqi1+=yuqi

                order_status = yihuan1 + '/' + weihuan1 + '/' + yuqi1


              
            }

            let obj = {
              order_no: order_no,
              order_id: order_id,
              create_time: create_time,
              total_price: total_price,
              order_source: order_source,
              order_source_text: order_source_text,
              order_status:order_status,
             
             }
            list.push(obj);
            // list.push(item);
            
          }
          console.log(list,'list')
          self.tableData.data = list;
          self.totalDataNumber = res.data.uid.length;
          self.exStyle = res.data.ex_style;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch((error) => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: "/order/order/Detail",
        query: {
          order_id: params,
        },
      });
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id,
      };
      // self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then((res) => {
          self.logisticsData = res.data.express.list;
          self.loading = false;
          self.openLogistics();
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },
  },
  filters: {
    // 过滤器
    // formatDate(create_time1) {
    //   let date = new Date(create_time1 * 1000);
    //   //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    //   let y = date.getFullYear();
    //   let MM = date.getMonth() + 1;
    //   MM = MM < 10 ? ('0' + MM) : MM; //月补0
    //   let d = date.getDate();
    //   d = d < 10 ? ('0' + d) : d; //天补0
    //   let h = date.getHours();
    //   h = h < 10 ? ('0' + h) : h; //小时补0
    //   let m = date.getMinutes();
    //   m = m < 10 ? ('0' + m) : m; //分钟补0
    //   let s = date.getSeconds();
    //   s = s < 10 ? ('0' + s) : s; //秒补0
    //   // return y + '-' + MM + '-' + d; //年月日
    //   return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
    // },
  },
};
</script>
<style lang="scss">
.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #ffa49f;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin: 10px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/duobiindex.vue